import { render } from "./coaches-invoice.vue?vue&type=template&id=03dbc8ba"
import script from "./coaches-invoice.vue?vue&type=script&lang=js"
export * from "./coaches-invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__